module.exports = __webpack_public_path__ + "img/list.98d509c1.png";